/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react'

import { jsx, Box, Text, Label, Checkbox } from 'theme-ui'
import styles from './styles'
import RichTextRender from '/components/Commons/RichTextRender'

const FormSectionConsents = ({
  cmsContent,
  register,
  errors,
  cmsErrorText,
}) => {
  const {
    consentEventsCheckboxLabel,
    consentEventsCheckboxText,
    consentEventsTable,
    consentMarketingCheckboxLabel,
    consentMarketingCheckboxText,
    consentMarketingTable,
    consentCheckboxAdvertisingInformation,
    consentTextAdvertisingInformation,
  } = cmsContent || {}

  return (
    <React.Fragment>
      <Box sx={styles.wrapper}>
        <Label
          sx={
            errors.consentCollectPersonalInformation
              ? {
                  ...styles.checkboxLabel,
                  ...styles.checkboxErrorLabel,
                }
              : styles.checkboxLabel
          }
        >
          <Checkbox
            name="consentCollectPersonalInformation"
            {...register('consentCollectPersonalInformation', {
              required: cmsErrorText,
            })}
          />
          {consentEventsCheckboxLabel}
        </Label>
        {errors.consentCollectPersonalInformation && (
          <Text sx={styles.formTextError}>{cmsErrorText}</Text>
        )}
        <Text sx={styles.checkboxText} as="p">
          {consentEventsCheckboxText}
        </Text>
        <RichTextRender
          tableId="consent-personal-information-table"
          tableClassName={styles.scrollTable}
          htmlCode={consentEventsTable}
        />
      </Box>

      <Box sx={styles.wrapper}>
        <Label
          sx={
            errors.consentCollectPersonalInformation
              ? {
                  ...styles.checkboxLabel,
                  ...styles.checkboxErrorLabel,
                }
              : styles.checkboxLabel
          }
        >
          <Checkbox
            name="consentMarketing"
            {...register('consentMarketing', {
              required: cmsErrorText,
            })}
          />
          {consentMarketingCheckboxLabel}
        </Label>
        {errors.consentMarketing && (
          <Text sx={styles.formTextError}>{cmsErrorText}</Text>
        )}
        <Text sx={styles.checkboxText} as="p">
          {consentMarketingCheckboxText}
        </Text>
        <RichTextRender htmlCode={consentMarketingTable} />
      </Box>

      <Box sx={styles.wrapper}>
        <Label
          sx={
            errors.consentCollectPersonalInformation
              ? {
                  ...styles.checkboxLabel,
                  ...styles.checkboxErrorLabel,
                }
              : styles.checkboxLabel
          }
        >
          <Checkbox
            name="consentAdvertising"
            {...register('consentAdvertising', {
              required: cmsErrorText,
            })}
          />
          {consentCheckboxAdvertisingInformation}
        </Label>
        {errors.consentAdvertising && (
          <Text sx={styles.formTextError}>{cmsErrorText}</Text>
        )}
        <RichTextRender htmlCode={consentTextAdvertisingInformation} />
      </Box>
    </React.Fragment>
  )
}

export default FormSectionConsents
